import { getAvatarSrc } from './../utils/helpers/getAvatarSrc';
import { makeObservable, action, observable, runInAction } from 'mobx';
import { AuthService, IUser, IUserStatus, IUserStatusRequest, MembersRequest, Store, axios } from '@utils';
import { Inject, Service } from 'typedi';

@Service()
export class MembersStore extends Store<IUser> {
  @Inject(() => MembersRequest)
  private membersRequest: MembersRequest;

  @observable.shallow membersWithCurrentUser: IUser[] = [];

  @observable.shallow membersStatus: Map<number, IUserStatus[]> = new Map<number, IUserStatus[]>();

  initPromise: Promise<void | []> = Promise.all([]);

  constructor() {
    super();
    makeObservable(this);
  }

  @action getMemberById = (id: number) => this.membersWithCurrentUser.find(member => member.id === id);

  @action getMembers = () => {
    if (!this.isLoading) {
      this.isLoading = true;
      this.initPromise = this.membersRequest.getMembers(false)
        .then((res) => runInAction(() => {
          if (res) {
            this.membersWithCurrentUser = res.data.map((elem) => ({ ...elem, img: getAvatarSrc(elem.id) }));
            this.excludeCurrentUser();
          }
          this.isLoading = false;
        }))
        .then(() => runInAction(() =>{
          this.membersWithCurrentUser.forEach((member) => {
            axios
              .get(member.img, { responseType: 'arraybuffer' })
              .then(response => {
                const blob = new Blob([response.data], { type: response.headers['content-type'] });
                const objectURL = URL.createObjectURL(blob);
                member.img = objectURL;
              });
          });
        }))
    }
    return this.initPromise;
  };

  @action excludeCurrentUser = () => {
    this.data = this.membersWithCurrentUser.filter(user => user.id !== AuthService.getUserId());
  };

  @action getMembersStatus = (interval: IUserStatusRequest) => {
    this.membersRequest.getMembersStatus(interval).then((res) => {
      if (res && Object.keys(res.data).length > 0) {
        this.membersStatus.clear();
        Object.keys(res.data).forEach((key) => {
          this.membersStatus.set(parseInt(key, 10), res.data[key] as IUserStatus[]);
        });
      }
    });
  };
}
